export class ReportNavMenu {
	ReportId!: string;
	ReportName!: string;
	ReportGroupName!: string;
	Active!: boolean;
	VsmExpress!: boolean;
}